import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-card-body',
    templateUrl: './card-body.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    // block host: an inline host around the block div adds empty line boxes (gaps) once it gets padding
    host: {class: 'block'}
})
export class CardBodyComponent {

}
